import Card from "./card";
import React, { useEffect, useState, useCallback } from "react";
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import { cyan, lightBlue, deepOrange, green, purple, orange, yellow, brown } from "@material-ui/core/colors";
import Axios from "axios";
import { LoadingSkeleton } from "../assets/skeletons";
import { NotFoundGeneral } from "../assets/notFound";
import ApplicationsList from "../applications/applicationsList";
import BottomMenu from "../footer/bottomMenu";

const cardContainerStyle = {
    display: 'flex',
}
const tableStyle = {
    margin: '0.5rem'
}
const Dashboard = (props) => {
    const [applications, setApplications] = useState(false);
    const [skeleton, setSkeleton] = useState(false);
    const [error, setError] = useState(false);

    const FetchApplications = useCallback(() => {
        setApplications(false);
        setSkeleton(true);
        setError({ code: false, message: "" });
        Axios.get(
            `${props.host}/applications/lastThirtyDays&limit=5                                       `,
            { headers: { Authorization: `Bearer ${props.token}` } })
            .then(res => {
                setApplications(res.data);

            })
            .catch((error) => {
                error && setError({ ...error, code: error.response.status, message: error.response.data });
            })
    }, []);

    useEffect(() => {
        FetchApplications();
    }, []);

    useEffect(() => {
        error.code && setSkeleton(false);
    }, [error]);
    return (<>
        <div style={cardContainerStyle}>
            <Card value={34} title="New Users" subtitle="$3,500 dlls in revenue" icon={EmojiEmotionsIcon} primaryColor={cyan[900]} secondaryColor={cyan[200]} textColor="white" chipPrimaryColor={deepOrange[500]} chipSecondaryColor="white" >
                <EmojiEmotionsIcon />
            </Card>
            <Card value={34} title="New Users" subtitle="$3,500 dlls in revenue" icon={EmojiEmotionsIcon} primaryColor={lightBlue[900]} secondaryColor={lightBlue[200]} textColor="white" chipPrimaryColor={green[500]} chipSecondaryColor={green[100]} >
                <EmojiEmotionsIcon />
            </Card>
            <Card value={34} title="New Users" subtitle="$3,500 dlls in revenue" icon={EmojiEmotionsIcon} primaryColor={orange[900]} secondaryColor={orange[200]} textColor="white" chipPrimaryColor={yellow[500]} chipSecondaryColor={brown[600]} >
                <EmojiEmotionsIcon />
            </Card>
            <Card value={34} title="New Users" subtitle="$3,500 dlls in revenue" icon={EmojiEmotionsIcon} primaryColor={purple[900]} secondaryColor={purple[200]} textColor="white" chipPrimaryColor={green[500]} chipSecondaryColor={green[100]} >
                <EmojiEmotionsIcon />
            </Card>
        </div>
        <div style={tableStyle}>
            {applications && <ApplicationsList host={props.host} token={props.token} data={applications} title="Last 5 apps" />}

            {error.code && <NotFoundGeneral message={error.message} />}
        </div>
        <BottomMenu />

    </>)
}
export default Dashboard;